var React = require('react');

function FlagNf (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M170.667 423.721H8.828A8.829 8.829 0 010 414.893V97.101a8.829 8.829 0 018.828-8.828h161.839v335.448z","fill":"#73af00","key":0}),React.createElement("path",{"fill":"#f5f5f5","d":"M170.67 88.277h170.67v335.45H170.67z","key":1}),React.createElement("g",{"fill":"#73af00","key":2},React.createElement("path",{"d":"M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 01512 97.101v317.792a8.828 8.828 0 01-8.828 8.828zM314.959 342.595l-27.396-159.812a49.976 49.976 0 00-6.402-17.266L256 123.583l-25.161 41.935a49.956 49.956 0 00-6.402 17.266L197.04 342.597a4.997 4.997 0 004.925 5.841h44.041v39.973h19.987v-39.974h44.041a4.997 4.997 0 004.925-5.842z"}))]);
}

FlagNf.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagNf;

FlagNf.default = FlagNf;
